/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".main-container[_ngcontent-%COMP%]{padding:4rem 2.5rem 1rem 2rem}.main-container-sub[_ngcontent-%COMP%]{font-family:PoppinsRegular,Arial,Helvetica,sans-serif;border:1px solid #ddd;border-radius:1rem}.main-container-sub[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:140px;height:140px;margin-top:-75px}.main-container-sub[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#444}.main-container-sub[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#ff6000;cursor:pointer}"];
export { styles as styles };
//# sourceMappingURL=leaderboard-error.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/leaderboard-error/leaderboard-error.component.scss.shim.ngstyle.js
// module id = 1632
// module chunks = 27 28 29